import { useQuery } from "react-query";
import Cookies from "js-cookie";
import axios from "axios";
import { serverBaseUrl } from "../config/envs";

const getTemplateDetails = async (token, id) => {
  try {
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await axios.get(`${serverBaseUrl}/get_template_details`, {
      headers,
      params: { id },
    });

    return response.data?.data;
  } catch (err) {
    let errorData = {
      status: err.response?.status,
      message: err.response?.statusText,
    };

    if (err.response?.data) {
      errorData = {
        ...errorData,
        message: err.response.data.message || errorData.message,
        messageCode: err.response.data.messageCode,
        data: err.response.data.data,
        success: err.response.data.success,
      };
    }

    throw new Error(JSON.stringify(errorData));
  }
};

export const useGetTemplateDetails = (id) => {
  const token = Cookies.get("token") || null;

  return useQuery(
    ["get_template_details", token, id],
    () => getTemplateDetails(token, id),
    {
      enabled: !!id,
      staleTime: 0,
      keepPreviousData: false,
    }
  );
};
